import { styled } from '@mui/material';

const PREFIX = 'InviteUserLedger';

export const inviteUserLedgerClasses = {
  buttonGroup: `${PREFIX}-buttonGroup`,
  radioButtonsGroup: `${PREFIX}-radioButtonsGroup`,
  button: `${PREFIX}-button`,
  buttonSelected: `${PREFIX}-buttonSelected`,
  boldLabel: `${PREFIX}-boldLabel`,
};

export const InviteUserLedgerRoot = styled('form')(({ theme }) => ({
  [`& .${inviteUserLedgerClasses.buttonGroup}`]: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
  },

  [`& .${inviteUserLedgerClasses.radioButtonsGroup}`]: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },

  [`& .${inviteUserLedgerClasses.button}`]: {
    margin: theme.spacing(0.5),
    border: 'none',
    borderRadius: '0.25rem',
    padding: '0.5rem 1rem',
    backgroundColor: theme.palette.primary[100],
    '&:hover': {
      backgroundColor: theme.palette.primary[200],
    },
  },

  [`& .${inviteUserLedgerClasses.buttonSelected}`]: {
    backgroundColor: theme.palette.primary[400],
    color: theme.palette.white,
  },

  [`& .${inviteUserLedgerClasses.boldLabel}`]: {
    fontWeight: 'bold',
    margin: theme.spacing(1, 0),
  },
}));